import { useState } from "react";
import { useTranslation } from "react-i18next";
import PopupContent from "../popupContent";
import "./ProductTreeSelector.css";


interface Props {
  selectionOfProductIsRequired: boolean;
  handleGroupSelection: any;
  handleProductSelection: any;
  handleCancellation: any;
  productGroups: any[];
  selectedGroup: any;
  selectedProductId: number;
}

const ProductTreeSelector = (props: Props) => {

  const { t } = useTranslation(undefined, { keyPrefix: 'ProductGroupsTree' });
  const [currentGroup, setCurrentGroup] = useState(props.selectedGroup);
  let initProducts: any[] = props.selectedGroup
    ? props.selectedGroup.products
    : [];

  const [currentProducts, setCurrentProducts] = useState(initProducts);

  const renderGroup = (productGroup: any, nested: boolean) => {
    let isItemSelectable =
      productGroup.isLeafGroup && !props.selectionOfProductIsRequired;

    let isGroupSelectable =
      productGroup.isLeafGroup && props.selectionOfProductIsRequired;
    let isGroupConfirmable =
      productGroup.isLeafGroup && !props.selectionOfProductIsRequired;

    let renderedNodeNameOrNameWithNumber;

    const name = t(`${productGroup.id}.name`) ?? productGroup.name;

    if (props.selectionOfProductIsRequired) {
      if (productGroup.products) {
        renderedNodeNameOrNameWithNumber = `${name} (${productGroup.products.length})`;
      } else {
        renderedNodeNameOrNameWithNumber = name;
      }
    } else {
      renderedNodeNameOrNameWithNumber = name;
    }

    let itemClassName = isItemSelectable
      ? `treeview-item-selectable`
      : `treeview-item`;

    if (currentGroup && currentGroup.id == productGroup.id) {
      itemClassName += " treeview-item-selected";
    }

    if (productGroup.isRootForDecorative) {
      itemClassName += " rootDecorative";
    }

    if (productGroup.isRootForIndustry) {
      itemClassName += " rootIndustry";
    }

    let nestedSelected = currentGroup && currentGroup.id == productGroup.id ? 'nested1selected' : '';
    return (
      <ul className={nested ? `nested1 ${nestedSelected}` : `treeview-animated-list mb-3`}>
        <li className="">
          <a className="closed">
            {!productGroup.isRootForIndustry &&
              !productGroup.isRootForDecorative && (
                <i className="fas fa-angle-right"></i>
              )}

            <span className="">
              {productGroup.isRootForDecorative && (
                <i className="fas fa-palette ic-w mx-1"></i>
              )}

              {productGroup.isRootForIndustry && (
                <i className="far fas fa-industry ic-w mx-1"></i>
              )}

              {!productGroup.isRootForIndustry &&
                !productGroup.isRootForDecorative && (
                  <i className="far fa-folder-open ic-w mx-1"></i>
                )}

              <span
                className={itemClassName}
                onClick={() => {
                  if (isGroupConfirmable) {
                    props.handleGroupSelection(productGroup);
                  }

                  if (isGroupSelectable) {
                    setCurrentGroup(productGroup);
                    setCurrentProducts(productGroup.products);
                  }
                }}
              >
                {renderedNodeNameOrNameWithNumber}
              </span>
              {productGroup.childGroups &&
                productGroup.childGroups.length > 0 &&
                productGroup.childGroups.map((childGroup: any) => {
                  return renderGroup(childGroup, true);
                })}
            </span>
          </a>
        </li>
      </ul>
    );
  };

  let selectedGroupData = !!currentGroup
    ? props.productGroups.filter((a) => a.id == currentGroup.id)
    : [];


  return (
    <PopupContent
      header={t('Header')}
      handleClose={props.handleCancellation}
    >
      <div className="productTreeSelectorContent">
        <div className="row">
          <div className="col-6" style={{ paddingRight: '0' }}>
            <div className="treeview-animated">
              {props.productGroups &&
                props.productGroups.length > 0 &&
                props.productGroups.map((productGroup) => {
                  return renderGroup(productGroup, false);
                })}
            </div>
          </div>
          {props.selectionOfProductIsRequired && props.productGroups.length ? (
            <div className="col-6" style={{ paddingLeft: '0', marginLeft: '-2px' }}>
              {currentProducts && currentProducts.length > 0 && (
                <div className="containerForProductsList">
                  <ul>
                    {currentProducts.map((product: any) => {
                      return (
                        <li
                          className={`${props.selectedProductId == product.id
                            ? "productItem-active"
                            : "productItem"
                            }`}
                          onClick={() => {
                            props.handleProductSelection(currentGroup, product);
                          }}
                        >
                          {product.name}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}

              {!currentProducts || currentProducts.length === 0 && (
                <div className="containerForProductsList"
                  style={{ textAlign: 'center' }}>
                  <span>{t('SelectCategoryFromLeftMenu')}</span>
                </div>
              )}
            </div>
          )
            :
            (
              <></>
            )
          }
        </div>
      </div>
    </PopupContent>
  );
};

export default ProductTreeSelector;
